import { TablePagination } from "@mui/material";
import type { TablePaginationProps } from "@mui/material";

/**
 * 페이지네이션 컴포넌트 속성
 */
export type PaginationProps = Omit<
  TablePaginationProps,
  "component" | "rowsPerPageOptions"
>;

/**
 * 페이지네이션 컴포넌트
 *
 * @param {PaginationProps} props 페이지네이션 컴포넌트 속성
 * @returns {JSX.Element} 페이지네이션 컴포넌트
 */
export const Pagination = (props: PaginationProps) => {
  return (
    <TablePagination
      component={"div"}
      {...props}
      rowsPerPageOptions={[10, 30, 50, 100]}
    />
  );
};
